<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content pb-4">
        <HelperNav />
          <div class="dashboard-wrapper">

            <div class="ar-card mb-5">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  معرفی به دوستان 
                </div>
                <div>
                </div>
              </div>
              <div class="ar-card-body">
                
                  <div class="refer-property-box">
                  <div class="refer-property-box-item right">
                    <h3>نقدی <i class="mdi mdi-information-outline"></i></h3>
                    <h1>{{formatPrice(userData.user_detail.irr_cash)}}</h1>
                    <div>
                      <button class="ar-btn size-sm primary disabled">برداشت</button>
                    </div>
                  </div>
                  <div class="refer-property-box-item left">
                    <h3>اعتباری <i class="mdi mdi-information-outline"></i></h3>
                    <h1>{{formatPrice(userData.user_detail.irr_credit)}}</h1>
                    <div>
                      <button class="ar-btn size-sm primary disabled">افزودن به سبد خرید</button>
                    </div>
                  </div>
                  </div>

                
                <div class="ar-card size-sm mb-4">
                  <div class="ar-card-header">
                    <div class="ar-card-title">
                      لینک دعوت 
                    </div>
                    <div>
                    </div>
                  </div>
                  <div class="ar-card-body text-primary-dark">

                    <div class="text-right">برای معرفی دوستانتان و کسب درآمد از خرید و فروش آن ها لازم است ثبت نام از طریق لینک زیر صورت پذیرد.</div>
                      
                    <h3 class="text-left my-3">
                      <i class="mdi mdi-content-copy" @click="copy('https://arzine.org/register?rf='+userData.user_detail.referral_id)"></i>
                      https://arzine.org/register?rf={{userData.user_detail.referral_id}}
                    </h3>

                    <div class="text-right">شما می توانید از تلفن همراه ثبت شده خود در ارزینه هم برای معرفی دوستانتان استفاده نمایید.</div>
                    <div class="text-center mb-3 mt-4">
                      شماره ثبت شده شما: <span class="mx-3"> {{ userData.mobile_number }}</span>
                    </div>

                  </div>
                  
                </div>
                
                <div class="ar-card size-sm">
                  <div class="ar-card-header">
                    <div class="ar-card-title">
                      کاربران معرفی شده 
                    </div>
                    <div>
                    </div>
                  </div>
                  <div class="ar-card-body p-0">

                    <div class="ar-tabs mt-3 px-2">
                      <div class="ar-tab-item" :class="[active_tab == 'users' ? 'active' : '']" @click="active_tab = 'users'">
                        کاربران
                      </div>
                      <div class="ar-tab-item" :class="[active_tab == 'trans' ? 'active' : '']" @click="active_tab = 'trans'">
                        دریافت ها
                      </div>
                    </div>
                    
                    <div v-show="active_tab == 'users'" class="table-responsive">
                      <table class="table ar-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>مشخصات کاربر</th>
                            <th>تاریخ ثبت نام</th>
                            <th>جمع دریافتی</th>
                          </tr>
                        </thead>
                        <div v-if="!Object.keys(subsets).length" class="wallet-placeholder">هنوز موردی وجود ندارد .</div>
                        <tbody>
                          <tr v-for="(item , key) in subsets" :key="key">
                            <td>{{ key+1 }}</td>
                            <td>
                              {{ item.user_data }}
                            </td>
                            <td>
                              {{ item.create }}
                            </td>
                            <td>
                              {{ formatPrice(item.total_income) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-show="active_tab == 'trans'" class="table-responsive">
                      <table class="table ar-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>از کاربر</th>
                            <th>مقدار</th>
                            <th>دلیل</th>
                            <th>تاریخ</th>
                          </tr>
                        </thead>
                        <div v-if="!Object.keys(history).length" class="wallet-placeholder">هنوز موردی وجود ندارد .</div>
                        <tbody>
                          <tr v-for="(item , key) in history" :key="key">
                            <td>{{ key+1 }}</td>
                            <td>
                              {{ item.user_data }}
                            </td>
                            <td>
                              {{ formatPrice(item.amount) }}
                            </td>
                            <td>
                              {{ item.reason }}
                            </td>
                            <td>
                              {{ item.create }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                  
                </div>

              </div>
              

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import HelperNav from './partials/HelperNav'
export default {
  name: 'BankAccounts',
  components:{
    Sidebar,
    HelperNav,
    Header,
  },
  data : () => ({
    active_tab:'users',
    subsets:{},
    history:{}
  }),
  methods:{
    copy(text)
    {
      navigator.clipboard.writeText(text);

      this.$notify({
        group: 'foo',
        type: 'success',
        duration: 4000,
        text: 'متن با موفقیت کپی شد.'
      });

    },
    getData(){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.get(`getReferralData`,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.subsets = res.data.data.subsets
        this.history = res.data.data.history
        this.activeLoading(false)
      })
      .catch( () => {
        this.activeLoading(false)
      });

    },
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.checkConfirmed()
    
    this.getData()
  }
}
</script>